<template>
  <div class="get-students">
    <div class="content-container">
      <div>
        <SidebarNav />
      </div>
      <div class="get-students-table">
        <h2>Liste over alle studenter</h2>

        <h5>Søk<input type="text" placeholder="Skriv for å søke" /></h5>
        <table>
          <tr>
            <th><input type="checkbox" /></th>
            <th>Navn</th>
            <th>Email</th>
            <th>Modul</th>
            <th>Rediger</th>
          </tr>
          <tr v-for="student in allStudents" v-bind:key="student.id">
            <td v-if="student.module.name != 'Modul 0'"><input type="checkbox" /></td>
            <td v-if="student.module.name != 'Modul 0'">{{ student.firstName }} {{ student.lastName }}</td>
            <td v-if="student.module.name != 'Modul 0'">{{ student.email }}</td>
            <td v-if="student.module.name != 'Modul 0'">{{ student.module.name }}</td>
            <td v-if="student.module.name != 'Modul 0'">*</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapState } from "vuex";
import SidebarNav from "@/components/SidebarNav.vue";
export default {
  name: "GetStudents",
  data() {
    return {
      protocol: "https",
      address: "portal-api.getacademy.no",
      allStudents: [],
    };
  },
  components: {
    SidebarNav,
  },
  computed: {
    ...mapState(["userInfo"]),

    baseUrl() {
      return `${this.protocol}://${this.address}/api`;
    },

    authId() {
      return this.$auth.user.sub || null;
    },
  },
  async mounted() {
    await this.loadAll();
  },
  methods: {
    ...mapActions(["getUserInfo", "getToken"]),

    async loadAll() {
      this.getUserInfo();
      this.getAllStudents();
    },

    async getAllStudents() {
      await this.getToken();

      await axios
        .get(`${this.baseUrl}/candidate`, this.$store.getters.axiosConfig)
        .then((response) => {
          this.allStudents = response.data;
        });
    },

    getUserId() {
      this.userId = null;
      axios
        .get(`${this.baseUrl}/candidate/${this.$auth.user.sub}`)
        .then((response) => {
          console.log(`this.userId = ${response.data.userId}`);
          this.userId = response.data.userId;
          this.getUserInfo();
          this.getUserProjects();
        });
    },

    getUserInfo() {
      this.userInfo = null;
      axios
        .get(`${this.baseUrl}/candidate/${this.$auth.user.sub}`)
        .then((response) => {
          console.log(`this.userInfo = ${response.data}`);
          this.userInfo = response.data;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.content-container {
  display: flex;
  flex-direction: row;
}

.get-students-table {
  width: 100%;
}

table {
  width: 100%;
}

table,
th {
  border-collapse: collapse;
}

th {
  &:first-child {
    text-align: left;
  }
  min-width: 50px;
  border-top: 1px solid grey;
  border-bottom: 1px solid grey;
}

th,
td {
  padding: 10px;
}

tr {
  &:nth-child(odd) {
    background-color: #ffffff;
  }
  &:nth-child(even) {
    background-color: var(--secondary-background-color);
  }
}

input[type="checkbox"] {
}
  input[type="checkbox"]:checked {
    color: red;
    background-color: red;
  }
</style>